import { type Dtos, type SuretyAccountId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { balanceSheetsQueryKey } from "./financials.keys";

export const useFetchBalanceSheets = (accountId: SuretyAccountId) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();
	const isAdmin = user.type === "admin";

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: balanceSheetsQueryKey(accountId),
		queryFn: async () =>
			get<Dtos.Admin.BalanceSheet.List.Response>(
				`/v2/${isAdmin ? "admin/" : ""}surety/accounts/${accountId}/balance-sheets`,
			),
	});

	return {
		balanceSheets: data,
		balanceSheetsError: error,
		balanceSheetsIsFetching: isFetching,
		balanceSheetsLoading: isLoading,
		refetchBalanceSheets: refetch,
	};
};
